/**
 * Produces a circular PNG with a white-filled background circle and the logo
 * cover-fit inside it, with transparent corners.
 *
 * qr-code-styling always clears a square bounding box behind the image.
 * By using this as the image and setting hideBackgroundDots: false, the white
 * circle masks the QR dots behind the logo while the transparent corners let
 * dots render through — making the cleared area appear circular.
 */
export const processLogoForQR = (logoUrl, size = 300) =>
  new Promise((resolve, reject) => {
    if (!logoUrl) return resolve(null);

    let cleanUrl = logoUrl;
    if (cleanUrl.includes("&token")) {
      cleanUrl = cleanUrl.split("&")[0];
    }

    const img = new Image();
    img.crossOrigin = "anonymous";
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext("2d");

      // Fill a white circle (transparent corners stay transparent)
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.fillStyle = "#ffffff";
      ctx.fill();

      // Clip to the same circle before drawing the logo
      ctx.beginPath();
      ctx.arc(size / 2, size / 2, size / 2, 0, Math.PI * 2);
      ctx.clip();

      // Cover-fit the logo inside the circle
      const ratio = img.width / img.height;
      let dw, dh, dx, dy;
      if (ratio > 1) {
        dh = size;
        dw = size * ratio;
        dx = -(dw - size) / 2;
        dy = 0;
      } else {
        dw = size;
        dh = size / ratio;
        dx = 0;
        dy = -(dh - size) / 2;
      }
      ctx.drawImage(img, dx, dy, dw, dh);

      resolve(canvas.toDataURL("image/png"));
    };
    img.onerror = () => reject(new Error("Failed to load logo"));
    img.src = cleanUrl;
  });
